import script from "./ConfigList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigList.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigList.vue?vue&type=style&index=0&id=f9095870&scoped=true&sccs=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9095870"]])

export default __exports__